module.exports = __webpack_public_path__ + "static/media/california.5cb411c3.png";